import api from '.'
import apiEndpoints from '../const/apiEndpoints'

interface OrderCreationPayload {
  user: string
  amount: Number
}

const createPaymentOrderId = async (
  data: OrderCreationPayload
): Promise<string> => {
  const response = await api.post(apiEndpoints.createPaymentOrder, data)
  return response?.data?.data
}

export default createPaymentOrderId
